import React, { useState } from 'react';
import { RiMapPinLine } from 'react-icons/ri';
import FilterDropdown from './FilterDropdown';

const countryOptions = [
    { label: 'Location (any)', value: 'Location (any)' },
    { label: 'United States', value: 'United States' },
    { label: 'Canada', value: 'Canada' },
];

const CountryDropdown = ({ onChange, isOpen, onToggle, onClose, className }) => {
    const [value, setValue] = useState(null);

    const handleSelect = (option) => {
        setValue(option);
        onClose();
        onChange(option);
    };

    return (
        <FilterDropdown
            icon={RiMapPinLine}
            label="Location"
            value={value}
            options={countryOptions}
            isOpen={isOpen}
            onToggle={onToggle}
            onClose={onClose}
            onSelect={handleSelect}
            className={className}
        />
    );
};

export default CountryDropdown;
